import React, { type ReactNode, type SyntheticEvent } from 'react';
import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import Heading from '@atlaskit/heading';
import CloseIcon from '@atlaskit/icon/core/migration/cross';
import { Box, Flex, xcss } from '@atlaskit/primitives';
import Tooltip from '@atlaskit/tooltip';
import { IconButton } from '@atlaskit/button/new';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages.tsx';

export type Props = {
	title: string;
	onClose: (arg1: SyntheticEvent<HTMLElement>, arg2: UIAnalyticsEvent) => void;
	toggleGraphSideBarAction?: React.ReactNode;
};

export const GraphHeader = ({ title, onClose, toggleGraphSideBarAction }: Props) => {
	const { formatMessage } = useIntl();
	return (
		<Flex alignItems="center" xcss={wrapperNewObjectGraphStyles}>
			<Title>{title}</Title>
			<Flex alignItems="center" justifyContent="space-between">
				<Box xcss={sidebarActionBorderStyles}>{toggleGraphSideBarAction}</Box>
				<Tooltip content={formatMessage(messages.closeLabel)} position="top">
					<IconButton
						icon={CloseIcon}
						appearance="subtle"
						onClick={onClose}
						testId="assets-graph-header.button-close"
						label={formatMessage(messages.closeButtonIcon)}
					/>
				</Tooltip>
			</Flex>
		</Flex>
	);
};

const Title = ({ children }: { children?: ReactNode }) => (
	<Box xcss={titleStyles}>
		<Heading size="large" as="h1">
			{children}
		</Heading>
	</Box>
);

const wrapperNewObjectGraphStyles = xcss({
	boxSizing: 'border-box',
	padding: 'space.300',
	borderBottomWidth: '1px',
	borderBottomStyle: 'solid',
	borderBottomColor: 'color.border',
	height: '72px',
});

const titleStyles = xcss({
	color: 'color.text',
	margin: 'space.0',
	flexGrow: '1',
	marginTop: 'space.050',
	paddingBottom: 'space.050',
	fontWeight: 'font.weight.regular',
});

const sidebarActionBorderStyles = xcss({
	paddingRight: 'space.100',
	borderRightWidth: '2px',
	borderRightStyle: 'solid',
	borderRightColor: 'color.border',
	marginRight: 'space.100',
});
